export const env = {
  SHOPIFY_CDN_BASE_URL: "__SHOPIFY_CDN_BASE_URL__",
  REDO_API_SERVER_URL: "__REDO_API_SERVER_URL__",
  REDO_CUSTOMER_PORTAL_SERVER_URL: "__REDO_CUSTOMER_PORTAL_SERVER_URL__",
  MERCHANT_SERVER_URL: "__MERCHANT_SERVER_URL__",
} as const;

// Development URLs for debugging (Coverage)
// export const env = {
//   SHOPIFY_CDN_BASE_URL: "https://shopify-cdn.getredo.com",
//   REDO_API_SERVER_URL: "https://api.getredo.com",
//   REDO_CUSTOMER_PORTAL_SERVER_URL: "https://customer-portal-server.getredo.com",
//   MERCHANT_SERVER_URL: "https://app-server.getredo.com",
// } as const;

// Development URLs for debugging (Danny)
// export const env = {
//   SHOPIFY_CDN_BASE_URL: "__SHOPIFY_CDN_BASE_URL__",
//   REDO_API_SERVER_URL: "https://api.getredo.dev",
//   REDO_CUSTOMER_PORTAL_SERVER_URL: "https://customer-portal.getredo.dev",
//   MERCHANT_SERVER_URL: "https://m-server.getredo.dev",
// } as const;

// Development URLs for debugging (Devin)
// export const env = {
//   SHOPIFY_CDN_BASE_URL: "__SHOPIFY_CDN_BASE_URL__",
//   REDO_API_SERVER_URL: "https://api-devin.getredo.dev",
//   REDO_CUSTOMER_PORTAL_SERVER_URL: "https://customer-portal-devin.getredo.dev",
//   MERCHANT_SERVER_URL: "https://merchant-server-devin.getredo.dev",
// } as const;

// Development URLs for debugging (Tommy)
// export const env = {
//   SHOPIFY_CDN_BASE_URL: "__SHOPIFY_CDN_BASE_URL__",
//   REDO_API_SERVER_URL: "https://api-tommy.getredo.dev",
//   REDO_CUSTOMER_PORTAL_SERVER_URL: "https://customer-portal-tommy.getredo.dev",
//   MERCHANT_SERVER_URL: "https://merchant-server-tommy.getredo.dev",
// } as const;
